export class Menu {
  name = "";
  path = "";
  sortOrder = 0;
  type = 1;
  typeIcon = null;
  auth = [];
  isVisible = true;
}
